import React from 'react';
import Loadable from 'react-loadable';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../../components/loading_spinner/loading_spinner')
);

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('./innovation_by_design_page_2018').default;
}

export default function(store) {
  const routeConfig = {
    path: '/innovation-by-design/:year/company/:company',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "ibd2018CompanyPage" */ './innovation_by_design_page_2018').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store);
          return Component;
        }
      );
    },
    chunk: 'ibdPage',
    autoScrollOff: true
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
